import React from 'react';
import styled from 'styled-components';
import closeIcon from '../../assets/icons/close_small.svg';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  /* justify-content: center;
  align-items: center; */
  z-index: 1000;
`;

const Main = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  max-height: 550px;
  max-width: 400px;
  height: 100%;
  width: 100%;
  top: 90px;
  left: 1080px;
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Modal = ({ isOpen, label, handleClose, children }) => {
  if (!isOpen) return null;

  return (
    <Container>
      <Main>
        <Title>
          {label}
          <button
            style={{
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
            }}
            onClick={handleClose}
          >
            <img src={closeIcon} alt='Close' />
          </button>
        </Title>
        {children}
      </Main>
    </Container>
  );
};

export default Modal;
